import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

const style = {
    height: "1rem !important",
    width: "1rem !important",
}

export const CircularProgressStyled = () => {
  return (
      <CircularProgress sx={style} />
  );
};
